import React from 'react'
import FeedList from '../components/FeedList'
import Rater from 'react-rater' // https://www.npmjs.com/package/react-rater
import 'react-rater/lib/react-rater.css'
import '../components/MyRater.css'  // to override the default colors - e.g. make them yellow

import GameList from '../data/GameList'  // don't think this should be here ...
import ActivityList from '../data/ActivityList'
import PlayerList from '../data/PlayerList'

const ViewGame = (props) => {
  //console.log(JSON.stringify(props));
  const gameId = Number(props.match.params.id);
  const gameInfo = GameList[gameId];
  const activityList = ActivityList.getActivityForGame(gameId);

  const list = activityList.map((event, index) => {
    // add 'playerName' to the scores info, and do a deep copy
    let newevent = JSON.parse(JSON.stringify(event));
    newevent.scores.forEach( (score) => {
      score.playerName = PlayerList[score.playerId].name;
    });
    //console.log('NEWEVENT: ' + JSON.stringify(newevent));
    return newevent;
  });

  let gameImage = '';
  if (gameInfo.logo) {
    let imgurl = '/' + gameInfo.logo;
    if (gameInfo.logo.startsWith("http")) {
      imgurl = gameInfo.logo;
    }
    gameImage = <img className="gameimage" src={imgurl} alt={gameInfo.name} style={{width: '200px'}}/>;
  }

  return (
    <div>
      <div className="gameActivityHeader">
        <h1>{gameInfo.name} Games</h1>
        <div div_gameimage>{gameImage}</div>
        <Rater total={5} rating={2} interactive={true}/>
      </div>
      <div className="gameActivityList">
        <FeedList activityList={list} includeImages={false}/>
      </div>
    </div>
  );
};

export default ViewGame;



// WEBPACK FOOTER //
// ./src/containers/ViewGame.js